<div class="status-container">

    <div class="icon">
        <div class="icon">
            <i [class]="data.type === 'offline'
            ? 'bi bi-wifi-off'
            : 'bi bi-cloud-slash'">
            </i>
        </div>
    </div>

    <div class="content">
        <div class="title text-primary">
            {{ data.type === 'offline'
            ? 'Internet Connection Lost'
            : 'Service Unavailable' }}
        </div>

        <div class="message">
            {{ data.type === 'offline'
            ? 'Please check your internet connection.'
            : 'Our services are temporarily unavailable. We are working to restore access.' }}
        </div>
    </div>

</div>